import { useState } from 'react';
import { NoteTypeClient, NoteTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useNoteTypeApi = () => {
    const apiClient = new NoteTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: NoteTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createNoteType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating NoteType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: NoteTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateNoteType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating NoteType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getNoteTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching NoteType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchNoteTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching NoteTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteNoteType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting NoteType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};